// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.
import { registry } from "./registry";

export * from "./AcademicSubject";
export * from "./AcademicTerm";
export * from "./AcademicYear";
export * from "./Address";
export * from "./Announcement";
export * from "./AttendanceStatus";
export * from "./BillingAdjustment";
export * from "./Building";
export * from "./BuildingFloor";
export * from "./CalendarEvent";
export * from "./CalendarEventResponse";
export * from "./Campus";
export * from "./ClassYear";
export * from "./ClassYearCategory";
export * from "./Contract";
export * from "./ContractInstallment";
export * from "./ContractLineItem";
export * from "./Country";
export * from "./Course";
export * from "./CourseAssessment";
export * from "./CourseAssessmentCategory";
export * from "./CourseAssessmentCategoryMarkPortion";
export * from "./CourseAssessmentMark";
export * from "./CourseAssessmentSubmission";
export * from "./CourseAssessmentTiming";
export * from "./CourseAttendanceRecord";
export * from "./CourseSection";
export * from "./CourseSectionPeriod";
export * from "./Discount";
export * from "./EmailAddress";
export * from "./Employee";
export * from "./EnrollmentApplication";
export * from "./EnrollmentApplicationGuardian";
export * from "./EnrollmentApplicationStudent";
export * from "./EnrollmentApplicationStudentSchool";
export * from "./Guardian";
export * from "./HomeRoom";
export * from "./HomeRoomSection";
export * from "./Invoice";
export * from "./InvoiceLineItem";
export * from "./Language";
export * from "./LearningObjective";
export * from "./LearningObjectiveCategory";
export * from "./LoginRecord";
export * from "./MFAFactor";
export * from "./MFAInvalidOTPAttempt";
export * from "./MarkValue";
export * from "./MarkingSystem";
export * from "./MediaAttachment";
export * from "./MedicalCondition";
export * from "./Medication";
export * from "./Message";
export * from "./MessageAvailabilityPeriod";
export * from "./MessageGroup";
export * from "./MessageGroupArchivePoint";
export * from "./MessageTopic";
export * from "./Newsletter";
export * from "./Payment";
export * from "./PaymentLineItem";
export * from "./Permission";
export * from "./PermissionGroup";
export * from "./Person";
export * from "./PhoneNumber";
export * from "./Post";
export * from "./Quotation";
export * from "./Refund";
export * from "./Relationship";
export * from "./ReportCard";
export * from "./ReportCardSection";
export * from "./ReportCardSectionLearningObjective";
export * from "./ReportCardSectionPolicy";
export * from "./Room";
export * from "./SchoolAttendanceRecord";
export * from "./Service";
export * from "./Session";
export * from "./SharingRecord";
export * from "./SocialComment";
export * from "./SocialReaction";
export * from "./Student";
export * from "./StudentAcademicNote";
export * from "./StudentAcademicTermEnrollment";
export * from "./StudentAttendanceNote";
export * from "./StudentBehaviorNote";
export * from "./StudentCourseSectionEnrollment";
export * from "./StudentDataConsent";
export * from "./StudentEnrollmentApplication";
export * from "./StudentEnrollmentIntent";
export * from "./StudentHealthNote";
export * from "./StudentHomeRoomSectionEnrollment";
export * from "./StudentIncidentNote";
export * from "./StudentInformationVerification";
export * from "./StudentInjuryNote";
export * from "./StudentMedicalCondition";
export * from "./StudentMedicalContact";
export * from "./StudentMedicalEvent";
export * from "./StudentMedicalProfile";
export * from "./StudentMedicationNote";
export * from "./StudentNote";
export * from "./StudentOTCMedication";
export * from "./StudentPrescriptionMedication";
export * from "./StudentSocialEmotionalNote";
export * from "./StudentVaccinationRecord";
export * from "./TeacherCourseSectionEnrollment";
export * from "./TeacherHomeRoomSectionEnrollment";
export * from "./TrustedDevice";
export * from "./User";
export * from "./UserGroup";
export * from "./UserViewRecord";
export * from "./Vaccine";

registry.run();
